import { SidebarInset, SidebarProvider } from '@1trading/react';
import type React from 'react';
import { Outlet } from 'react-router-dom';
import AppSidebar from '@/layouts/default/app-sidebar';
import { BottomNav } from '@/layouts/default/bottom-nav';
import Header from '@/layouts/default/header';
import { NonProdBanner } from '@/layouts/default/non-prod-banner';
import { getCookie } from '@/utils/cookie';

export const DefaultLayout = () => {
  // The library's SidebarProvider persists toggles to the `sidebar_state` cookie;
  // default to open when no preference is stored (ops portal norm).
  const sidebarDefaultOpen = getCookie('sidebar_state') !== 'false';

  return (
    <SidebarProvider
      defaultOpen={sidebarDefaultOpen}
      style={
        {
          '--sidebar-width-icon': '3.5rem',
        } as React.CSSProperties
      }
    >
      <NonProdBanner />
      <AppSidebar />
      {/* min-w-0 down the flex chain: without it, wide content (tables) widens the
          page and the whole site scrolls horizontally instead of the table's own
          overflow-x-auto wrapper doing the scrolling */}
      <SidebarInset className="min-w-0">
        <Header />
        {/* A div, not a main: SidebarInset already renders the page's <main> landmark.
            Extra bottom padding clears the fixed mobile nav bar (and the iOS home indicator).
            Pages with sticky UI opt out of the scroll container via data-sticky-page, since it would trap position: sticky */}
        <div className="min-w-0 flex-1 overflow-y-auto p-6 has-[[data-sticky-page]]:overflow-visible has-[[data-sticky-page]]:overflow-x-clip pb-[calc(var(--bottom-nav-height)+env(safe-area-inset-bottom)+1.5rem)] md:pb-6">
          <Outlet />
        </div>
      </SidebarInset>
      <BottomNav />
    </SidebarProvider>
  );
};
DefaultLayout.displayName = 'DefaultLayout';
